import './events.scss';
import Swiper from 'swiper/bundle';
import Shuffle from 'shufflejs';
import Selectr from 'mobius1-selectr';

class Events {
    constructor(element) {
        this.$lang = document.documentElement.lang;

        this.$el = element;
        this.activeMonthFilter = null;

        this.$grid = this.$el.querySelector('[data-grid="root"]');
        this.$shuffle = null;

        this.$locationSelect = null;
        this.$locationSelectEl = this.$el.querySelector(
            '.events__filters--locations select'
        );
        this.$selectedLocations = [];

        this.initialize();
    }

    initialize() {
        this.initMonthsSlider();
        this.initMonthsFilter();
        this.initLocationsFilter();
        this.initGrid();
        this.setNoEventsFoundContainer(false);
    }

    initMonthsSlider() {
        const el = this.$el.querySelector('.swiper');
        if (!el) return;

        this.monthsSlider = new Swiper(el, {
            loop: false,
            spaceBetween: 32,
            slidesPerView: 'auto',
            freeMode: true,
            grabCursor: true,
            centeredSlides: false,
            breakpoints: {
                0: {
                    spaceBetween: 16
                },
                768: {
                    spaceBetween: 32
                }
            }
        });
    }

    initMonthsFilter() {
        [...this.$el.querySelectorAll('.events__filter--month')].forEach(
            (el) => {
                const monthsFilter = (e) => {
                    const filter = e?.target?.dataset?.filter;

                    const noMonthFilter = this.$el.querySelector(
                        '.events__filter--month:first-of-type'
                    );

                    [
                        ...this.$el.querySelectorAll('.events__filter--month')
                    ].forEach((el) => {
                        el.classList.toggle('active', false);
                    });

                    if (!filter) {
                        noMonthFilter.classList.toggle('active', true);
                        this.activeMonthFilter = null;
                    } else {
                        if (this.activeMonthFilter === filter) {
                            noMonthFilter.classList.toggle('active', true);
                            this.activeMonthFilter = null;
                        } else {
                            e.target.classList.toggle('active', true);
                            this.activeMonthFilter = filter;
                        }
                    }

                    this.filterGrid();
                };
                el.addEventListener('click', (e) => {
                    monthsFilter(e);
                });

                el.addEventListener('keypress', (e) => {
                    if (e.which === 13 || e.which === 32) {
                        e.preventDefault();

                        monthsFilter(e);
                    }
                });
            }
        );
    }

    initGrid() {
        this.$shuffle = new Shuffle(this.$grid, {
            itemSelector: '.event-item',
            gutterWidth: 25
        });

        this.sortGrid();
    }

    sortGrid() {
        this.$shuffle.sort({
            reverse: false,
            by: function (element) {
                return element.dataset.index;
            }
        });
    }

    filterGrid() {
        this.$shuffle.filter((element) => {
            if (!this.activeMonthFilter && !this.$selectedLocations.length) {
                return true;
            }

            const monthValid = (el) => {
                return el.dataset.month === this.activeMonthFilter;
            };

            const locationValid = (el) => {
                return (
                    this.$selectedLocations.filter(
                        (l) => l.value === el.dataset.location
                    )?.length > 0 || false
                );
            };

            if (this.activeMonthFilter && !this.$selectedLocations.length) {
                return monthValid(element);
            }

            if (!this.activeMonthFilter && this.$selectedLocations.length) {
                return locationValid(element);
            }

            if (this.activeMonthFilter && this.$selectedLocations.length) {
                return monthValid(element) && locationValid(element);
            }

            return false;
        });

        this.setNoEventsFoundContainer(this.$shuffle.visibleItems === 0);
    }

    setNoEventsFoundContainer(show = false) {
        const el = this.$el.querySelector('.events__no-events-found');
        el.style.display = show ? 'block' : 'none';
    }

    initLocationsFilter() {
        this.$locationSelect = new Selectr(this.$locationSelectEl, {
            searchable: false,
            width: 300,
            renderOption: (option) => {
                return `<div class="events__filter--location">
                    <div class="events_filter--box"></div>
                    <div class="events_filter--value" tabindex="0" onkeydown="((e) => e.which === 13 || e.which === 32 ? (e.preventDefault(), e.target.click()) : null)(event)">${option.innerHTML}</div>
                </div>`;
            },
            taggable: false
        });

        this.$locationSelect.on('selectr.init', function () {
            document
                .getElementsByClassName('selectr-selected')[0]
                .addEventListener('keypress', (e) => {
                    if (e.which === 13 || e.which === 32) {
                        e.preventDefault();
                    }
                });
        });

        const setPlaceholderText = () => {
            const text =
                this.$lang === 'de'
                    ? this.$selectedLocations.length === 0
                        ? `Standorte (<strong>alle</strong>)`
                        : `Standorte (<strong>${this.$selectedLocations.length}</strong>)`
                    : this.$selectedLocations.length === 0
                    ? `Locations (<strong>all</strong>)`
                    : `Locations (<strong>${this.$selectedLocations.length}</strong>)`;

            this.$el.querySelector(
                '.events__filters--locations .selectr-placeholder'
            ).innerHTML = text;
        };

        const setSelectedFilterTags = () => {
            let template = '';

            if (this.$selectedLocations.length) {
                template = this.$selectedLocations
                    .map(
                        (location) => `
                            <div class="events__filters--selected-filter active" data-location-filter="${location.value}">
                                <span>${location.text}</span>
                                <span class="close"></span>
                            </div>`
                    )
                    .join('');

                template += `<div class="events__filters--selected-filter" data-location-filter-delete>
                                ${
                                    this.$lang === 'de'
                                        ? 'Filter löschen'
                                        : 'Delete filters'
                                }
                            </div>`;
            }

            this.$el.querySelector(
                '.events__filters--selected-filters'
            ).innerHTML = template;

            updateSelectedFilterTagEvents();
        };

        const updateSelectedFilterTagEvents = () => {
            const deleteButton = this.$el.querySelector(
                '[data-location-filter-delete]'
            );
            deleteButton?.removeEventListener('click', handleDeleteFilterTags);
            deleteButton?.addEventListener('click', handleDeleteFilterTags);

            const deleteSingleFilterButtons = this.$el.querySelectorAll(
                '[data-location-filter]'
            );
            deleteSingleFilterButtons?.forEach((button) => {
                button?.removeEventListener(
                    'click',
                    handleDeleteSingleFilterTag
                );
                button?.addEventListener('click', handleDeleteSingleFilterTag);
            });
        };

        const handleDeleteFilterTags = () => {
            this.$locationSelect.clear();
            updateSelectedLocations(true);
        };

        const handleDeleteSingleFilterTag = (e) => {
            const location =
                e?.target?.dataset?.locationFilter ||
                e?.target?.parentElement?.dataset?.locationFilter;

            if (!location) return;

            const locationFilterValues = this.$locationSelect.getValue();

            this.$locationSelect.setValue(
                locationFilterValues.filter(
                    (selectedLocation) => selectedLocation === location
                )
            );

            updateSelectedLocations();
        };

        const handleLocationFilterChange = () => {
            updateSelectedLocations();
        };

        const updateSelectedLocations = (clear = false) => {
            this.$selectedLocations = clear
                ? []
                : this.$locationSelect.getValue(true)?.values || [];

            setPlaceholderText();
            setSelectedFilterTags();
            this.filterGrid();
        };

        this.$locationSelect.on('selectr.select', handleLocationFilterChange);
        this.$locationSelect.on('selectr.deselect', handleLocationFilterChange);

        setPlaceholderText();
    }
}

export { Events };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $events = $context.querySelectorAll('[data-events="root"]');
        for (let i = 0; i < $events.length; i++) {
            const isPreview = $events[i].dataset.preview === 'true';
            if (isPreview) continue;

            $events[i].API = new Events($events[i]);
        }
    }
});
